/**
 * ═══════════════════════════════════════════════════════════════════════════════
 * MODE DÉMO — kiosk de démonstration pour prospects
 * ═══════════════════════════════════════════════════════════════════════════════
 *
 * Le site démo est installé sous SON PROPRE LIEN (ex. demo.restomi.fr), séparé des vrais
 * kiosks clients. Le CLIENT peut tout tester (commander), mais NE PEUT PAS accéder à
 * l'admin ni changer les réglages. Seul TOI, avec ton code secret, débloques l'admin.
 *
 * ═══════════════════════════════════════════════════════════════════════════════
 * ACTIVATION AUTOMATIQUE PAR L'URL — rien à changer avant de builder
 * ═══════════════════════════════════════════════════════════════════════════════
 * Le mode démo s'active TOUT SEUL si l'adresse du site contient l'un des marqueurs
 * ci-dessous (DEMO_HOST_MARKERS), par ex. "demo" dans "demo.restomi.fr".
 *
 *   • demo.restomi.fr   → MODE DÉMO (admin verrouillé par code)   ✅
 *   • kiosk.restomi.fr  → mode normal (admin par 10 clics)        ✅
 *
 * → Le MÊME build peut aller sur la démo ET sur un vrai kiosk sans risque : un vrai
 *   kiosk ne sera JAMAIS verrouillé, car son URL ne contient pas "demo".
 *
 * ⚠️ Sécurité : le code admin est en DUR dans le build. Quelqu'un qui inspecte le JS
 * pourrait le retrouver. C'est volontairement simple — assez pour empêcher un client
 * lambda de bidouiller la démo, PAS une sécurité forte.
 */

/** Marqueurs cherchés dans le nom de domaine pour activer le mode démo. */
const DEMO_HOST_MARKERS = ['demo', 'demo-kiosk', 'kiosk-demo'];

/**
 * Forçage MANUEL (optionnel). Laisser `null` = détection auto par l'URL (recommandé).
 *   - true  → force le mode démo partout (pour tester en local)
 *   - false → force le mode normal partout
 *   - null  → auto selon l'URL
 */
const FORCE_DEMO: boolean | null = null;

/** Détecte si l'URL courante correspond au site démo. */
const detectDemoFromUrl = (): boolean => {
  try {
    if (typeof window === 'undefined' || !window.location) return false;
    const host = (window.location.hostname || '').toLowerCase();
    // ?demo=1 dans l'URL permet aussi de tester le mode démo manuellement
    const qs = (window.location.search || '').toLowerCase();
    if (qs.includes('demo=1')) return true;
    return DEMO_HOST_MARKERS.some((m) => host.includes(m));
  } catch {
    return false;
  }
};

/** true = ce chargement est un kiosk de DÉMONSTRATION (admin verrouillé par code). */
export const DEMO_MODE: boolean = FORCE_DEMO !== null ? FORCE_DEMO : detectDemoFromUrl();

/**
 * Code secret pour débloquer l'admin en mode démo.
 */
export const DEMO_ADMIN_CODE = 'Fahedbenjrad9@';

/**
 * Identifiants du STORE DÉMO (connexion automatique en mode démo).
 * Le visiteur n'a rien à taper : le kiosk se connecte tout seul sur ce store.
 */
export const DEMO_STORE_EMAIL = 'demo@gmail.com';
export const DEMO_STORE_PASSWORD = '123456';

/**
 * Vérifie le code saisi pour débloquer l'admin.
 * Comparaison EXACTE (sensible à la casse) ; on retire seulement les espaces
 * de début/fin au cas où le clavier en ajoute.
 */
export const isDemoAdminCodeValid = (input: string): boolean => {
  if (!input) return false;
  return input.trim() === DEMO_ADMIN_CODE;
};
